// Injects Aria Belle-style custom badges (reviews stars, promo banner, USP icons + stock
// warning, trust badge pill) into the native product-information section on PDP pages.
// Anchored on data-block-id suffixes set by templates/product.json, since Shopify's `text`
// block strips <style>/<svg>/custom markup from its richtext field — this keeps native
// variant-picker/buy-buttons functionality intact while giving full visual control.
(function () {
  function byBlockSuffix(suffix) {
    const byAttr = document.querySelector('[data-block-id$="' + suffix + '"]');
    if (byAttr) return byAttr;
    // some blocks (e.g. buy-buttons) expose the block id only via a CSS class suffix,
    // not a data-block-id attribute
    const all = document.querySelectorAll('[class*="' + suffix + '"]');
    return all.length ? all[0] : null;
  }

  function insertBefore(refEl, html) {
    if (!refEl) return null;
    const wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    const el = wrapper.firstElementChild;
    refEl.parentNode.insertBefore(el, refEl);
    return el;
  }

  function insertAfter(refEl, html) {
    if (!refEl) return null;
    const wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    const el = wrapper.firstElementChild;
    refEl.parentNode.insertBefore(el, refEl.nextSibling);
    return el;
  }

  const STAR_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';

  const reviewsHtml =
    '<span class="pdp-reviews-badge">' +
    '<span class="pdp-reviews-badge__stars">' + STAR_SVG.repeat(5) + '</span>' +
    '<span>Over <b>75,000+</b> satisfied customers</span>' +
    '</span>';

  const promoHtml =
    '<span class="pdp-promo-badge">' +
    '<svg fill="currentColor" viewBox="0 -960 960 960" width="18" height="18"><path d="M503-104q-24 24-57 24t-57-24L103-390q-23-23-23-56.5t23-56.5l352-353q11-11 26-17.5t32-6.5h286q33 0 56.5 23.5T879-800v286q0 17-6.5 32T855-456L503-104Zm196-536q25 0 42.5-17.5T759-700q0-25-17.5-42.5T699-760q-25 0-42.5 17.5T639-700q0 25 17.5 42.5T699-640ZM446-160l353-354v-286H513L160-446l286 286Zm353-640Z"/></svg>' +
    'LAST CALL EVENT — UP TO 60% OFF' +
    '</span>';

  const uspHtml =
    '<div class="pdp-usp">' +
    '<div class="pdp-usp__row">' +
    '<span class="pdp-usp__icon pdp-usp__icon--royal-mail"><img src="' + window.PDP_ROYAL_MAIL_ICON_URL + '" alt="Royal Mail" loading="lazy"></span>' +
    '<span>Free Shipping with <b>Royal Mail</b></span>' +
    '</div>' +
    '<div class="pdp-usp__row">' +
    '<span class="pdp-usp__icon"><img src="https://cdn.shopify.com/s/files/1/1114/1657/4290/files/icon-guarantee.png" alt="" loading="lazy"></span>' +
    '<span>30-Day Money-Back Guarantee</span>' +
    '</div>' +
    '<div class="pdp-usp__stock"><span class="pdp-usp__dot"></span><span>Almost out of stock!</span></div>' +
    '</div>';

  // Below Add to Cart: Last Call Event banner (this theme is the "Last Call Event" A/B-test
  // duplicate, 29-09 — separate sale concept from the live Autumn Edit theme, same layout/copy
  // pattern) replaces the old "30-day money back guarantee" trust pill.
  const trustHtml =
    '<div class="pdp-trust-wrap">' +
    '<div class="pdp-september-reset">' +
    '<p class="pdp-september-reset__title">LAST CALL EVENT</p>' +
    '<p class="pdp-september-reset__text">Selling fast. No restocks &mdash; if you can add it to cart, it&rsquo;s still yours.</p>' +
    '<p class="pdp-september-reset__sign">x, SELINE VALE</p>' +
    '</div>' +
    '</div>';

  // Bundle & Save box: same pattern as Caldwell Menswear's bundle-save-box.liquid, ported to
  // JS-injection (this theme's PDP badges are all client-side, see file header). Static/informational
  // — the actual stacking discount is a Shopify automatic discount (2=-10%, 3=-15%, 4+=-20%),
  // this box just communicates it. Placed directly under the September Reset banner, 29-09.
  const bundleSaveHtml =
    '<div class="pdp-bundle-save">' +
    '<div class="pdp-bundle-save__title">Bundle &amp; Save</div>' +
    '<div class="pdp-bundle-save__options">' +
    '<div class="pdp-bundle-save__option"><span>2 Items</span><span>-10%</span></div>' +
    '<div class="pdp-bundle-save__option"><span>3 Items</span><span>-15%</span></div>' +
    '<div class="pdp-bundle-save__option pdp-bundle-save__option--active"><span>4+ Items</span><span>-20%</span></div>' +
    '</div>' +
    '<div class="pdp-bundle-save__note">Discount applied automatically in cart.</div>' +
    '</div>';

  function addSaleBadge(priceEl) {
    if (!priceEl) return;
    const priceContainer = priceEl.querySelector('[ref="priceContainer"]') || priceEl;
    const existing = priceContainer.querySelector('.pdp-sale-badge');
    const sale = priceEl.querySelector('.price-item__group.price bdi, .price bdi');
    const compare = priceEl.querySelector('.compare-at-price bdi');
    if (!sale || !compare) {
      if (existing) existing.remove(); // variant switched to one with no compare-at price
      return;
    }
    const parseAmount = (text) => parseFloat(String(text).replace(/[^0-9.,]/g, '').replace(',', '.'));
    const salePrice = parseAmount(sale.textContent);
    const comparePrice = parseAmount(compare.textContent);
    if (!salePrice || !comparePrice || comparePrice <= salePrice) {
      if (existing) existing.remove();
      return;
    }
    const pct = Math.round((1 - salePrice / comparePrice) * 100);
    const label = 'Save ' + pct + '%';
    if (existing) {
      existing.textContent = label; // update in place, keep node identity stable
      return;
    }
    const badge = document.createElement('span');
    badge.className = 'pdp-sale-badge';
    badge.textContent = label;
    priceContainer.appendChild(badge);
  }

  // Shopify's variant-picker morphs product-price's inner DOM on variant change (AJAX section
  // re-render), which wipes out the badge node addSaleBadge() appended earlier — and inject()'s
  // own "already injected" guard (based on .pdp-reviews-badge, which never gets removed) skips
  // re-running addSaleBadge() on that later pass. Watch the price block directly so the badge
  // gets re-applied every time its DOM is replaced, independent of the one-time inject() guard.
  //
  // addSaleBadge() itself mutates this same subtree (appendChild / textContent), which would
  // re-trigger this observer forever (infinite mutate->observe->mutate loop, hangs the page) —
  // disconnect before calling it and reconnect after, so its own writes are never observed.
  function observePriceBlock() {
    const priceEl = byBlockSuffix('_price_block');
    if (!priceEl || priceEl.dataset.pdpSaleBadgeObserved) return;
    priceEl.dataset.pdpSaleBadgeObserved = 'true';
    const mo = new MutationObserver(function () {
      mo.disconnect();
      addSaleBadge(priceEl);
      mo.observe(priceEl, { childList: true, subtree: true });
    });
    mo.observe(priceEl, { childList: true, subtree: true });
  }

  function inject() {
    // Runs on every call (unlike the rest of inject(), which only needs to run once per
    // section render) so the price-block observer gets (re-)attached even when the early
    // return below skips everything else — observePriceBlock() itself is idempotent per element.
    observePriceBlock();

    if (document.querySelector('.pdp-reviews-badge')) return; // already injected (section re-render)

    // reviews: right before the title
    insertBefore(byBlockSuffix('_title_block'), reviewsHtml);

    // promo banner then USP block, both directly after price, in visual order
    const priceEl = byBlockSuffix('_price_block');
    addSaleBadge(priceEl);
    if (priceEl) {
      const promoEl = insertAfter(priceEl, promoHtml);
      insertAfter(promoEl || priceEl, uspHtml);
    }

    // trust badge (September Reset banner): directly after the buy-buttons block
    const buyButtonsEl = byBlockSuffix('_buy_buttons_block');
    const septemberResetEl = insertAfter(buyButtonsEl, trustHtml);

    // Bundle & Save box: directly under the September Reset banner
    insertAfter(septemberResetEl || buyButtonsEl, bundleSaveHtml);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
  document.addEventListener('shopify:section:load', inject);
})();
